import React from 'react';
import {
  DatePicker,
} from 'antd';
import PropTypes from 'prop-types';
import moment from 'moment';

function ManualEntryDateRangePicker({
  value,
  onChange,
}) {
  const momentValue = value ? [
    value[0] ? moment(value[0]) : null,
    value[1] ? moment(value[1]) : null,
  ] : null;
  const onDateChange = (newValues) => {
    onChange(newValues?.map((newValue) => newValue.format('YYYY-MM-DD')));
  };

  return (
    <DatePicker.RangePicker
      allowClear={false}
      value={momentValue}
      onChange={onDateChange}
    />
  );
}

ManualEntryDateRangePicker.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
};

ManualEntryDateRangePicker.defaultProps = {
  value: undefined,
};

export default ManualEntryDateRangePicker;
